import React from "react";
import { DateRange } from "react-date-range";
export default function DateFilter(props: FilterProps) {
  const onMouseEnter = () => {
    // setShow(!show);
    const el = document.querySelector(".date-range-holder");
    el?.classList.remove("d-none");
  };

  const onMouseOut = () => {
    const el = document.querySelector(".date-range-holder");
    el?.classList.add("d-none");
  };

  return (
    <div className="row">
      <div
        className={`${
          props.widthRange ? props.widthRange : "col-md-6"
        } col-12 text-right pt-2`}
      >
        <form autoComplete="off">
          <div
            className="input-group bg-light w-100 position-relative"
            onClick={onMouseEnter}
          >
            {props.labelPosition === "right" ? (
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-warning border-0 border-radius-none text-bold text-dark"
                  id="basic-addon1"
                >
                  Filter by Date
                </span>
              </div>
            ) : (
              ""
            )}

            <input
              type="text"
              autoComplete="off"
              placeholder={
                props.customPlaceholder
                  ? props.customPlaceholder
                  : "Today/Week/Custom"
              }
              className="form-control outline-0 bg-light border-0 date-range-hover"
              onClick={onMouseEnter}
              style={{ fontSize: "13px", fontWeight: "bold" }}
            />
            {props.labelPosition === "left" ? (
              <div className="input-group-prepend bg-light">
                <span
                  className="input-group-text bg-warning border-0 border-radius-none text-bold text-dark"
                  id="basic-addon1"
                >
                  Filter by Date
                </span>
              </div>
            ) : (
              ""
            )}

            <div
              className="position-absolute bg-white d-none animated fadeIn date-range-holder"
              style={{
                zIndex: 5000,
                top: 50,
                paddingBottom: 100,
              }}
              onMouseLeave={onMouseOut}
            >
              <DateRange
                onChange={props.handleSelect}
                showSelectionPreview={false}
                moveRangeOnFirstSelection={false}
                twoStepChange
                // months={2}
                ranges={props.ranges}
                direction="horizontal"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

interface FilterProps {
  customPlaceholder?: any;
  handleSelect?: any;
  ranges?: any;
  labelPosition?: string;
  width?: string;
  widthRange?: any;
}
